module.exports = __webpack_public_path__ + "static/media/blog3-image.10de8da3.jpg";